export default __webpack_public_path__ + "static/media/imageLink.beb14de0.svg";